export default __webpack_public_path__ + "64c19708e82cee28987fd3c7413844c4.png";